import * as THREE from 'three';

export type OrientationPose = 'default' | 'z-up' | 'x-up';

export const ORIENTATION_POSES: {
  key: OrientationPose;
  label: string;
  euler: [number, number, number];
}[] = [
  { key: 'default', label: 'Upright', euler: [0, 0, 0] },
  { key: 'z-up', label: 'Flat', euler: [-Math.PI / 2, 0, 0] },
  { key: 'x-up', label: 'On side', euler: [0, 0, Math.PI / 2] },
];

export function poseEuler(pose: OrientationPose): [number, number, number] {
  return (ORIENTATION_POSES.find((p) => p.key === pose) ?? ORIENTATION_POSES[0]).euler;
}

export function poseQuaternion(pose: OrientationPose): THREE.Quaternion {
  const [x, y, z] = poseEuler(pose);
  return new THREE.Quaternion().setFromEuler(new THREE.Euler(x, y, z));
}

export function applyPoseToGroup(group: THREE.Object3D, pose: OrientationPose): void {
  const ud = group.userData as { __poseBasePosY?: number; isArrangementWrapper?: boolean };
  if (ud.isArrangementWrapper) return;
  if (ud.__poseBasePosY === undefined) ud.__poseBasePosY = group.position.y;
  const basePosY = ud.__poseBasePosY;

  group.position.y = basePosY;
  group.rotation.set(0, 0, 0);
  group.updateMatrixWorld(true);
  const restingMinY = new THREE.Box3().setFromObject(group).min.y;

  const [x, y, z] = poseEuler(pose);
  group.rotation.set(x, y, z);
  group.updateMatrixWorld(true);
  const posedMinY = new THREE.Box3().setFromObject(group).min.y;

  if (Number.isFinite(restingMinY) && Number.isFinite(posedMinY)) {
    group.position.y = basePosY + (restingMinY - posedMinY);
    group.updateMatrixWorld(true);
  }
}
